export default {
    indexOccupancyAlertGroups:        { method: 'get',    url: 'occupancy_alert_groups' },
    showOccupancyAlertGroup:          { method: 'get',    url: 'occupancy_alert_groups/{id}' },
    createOccupancyAlertGroup:        { method: 'post',   url: 'occupancy_alert_groups' },
    updateOccupancyAlertGroup:        { method: 'put',    url: 'occupancy_alert_groups/{id}' },
    deleteOccupancyAlertGroup:        { method: 'delete', url: 'occupancy_alert_groups/{id}' },

    indexOccupancyTemplates:          { method: 'get',    url: 'occupancy_notification_templates' },
    showOccupancyTemplate:            { method: 'get',    url: 'occupancy_notification_templates/{id}' },
    createOccupancyTemplate:          { method: 'post',   url: 'occupancy_notification_templates' },
    updateOccupancyTemplate:          { method: 'put',    url: 'occupancy_notification_templates/{id}' },
    testOccupancyTemplate:            { method: 'post',   url: 'occupancy_notification_templates/{id}/test-mail' },

    showOccupancyAlertSendSettings:   { method: 'get',    url: 'occupancy_alert_send_settings' },
    updateOccupancyAlertSendSettings: { method: 'put',    url: 'occupancy_alert_send_settings' },

    showOccupancyComplianceEmails:    { method: 'get',    url: 'occupancy_compliance_emails' },
    updateOccupancyComplianceEmails:  { method: 'put',    url: 'occupancy_compliance_emails' },

    indexNotificationGroups:          { method: 'get',    url: 'occupancy_notification_groups' },
    showNotificationGroup:            { method: 'get',    url: 'occupancy_notification_groups/{id}' },
    createNotificationGroup:          { method: 'post',   url: 'occupancy_notification_groups' },
    updateNotificationGroup:          { method: 'put',    url: 'occupancy_notification_groups/{id}' },
    deleteNotificationGroup:          { method: 'delete', url: 'occupancy_notification_groups/{id}' },
    eligibleNotificationUsers:        { method: 'get',    url: 'occupancy_notification_groups/eligible-users' },
    addNotificationGroupMembers:      { method: 'post',   url: 'occupancy_notification_groups/{id}/members' },
    removeNotificationGroupMember:    { method: 'delete', url: 'occupancy_notification_groups/{id}/members/{userId}' },

    indexClosureReports:              { method: 'get',    url: 'occupancy_closure_reports' },
    nextScheduledClosure:             { method: 'get',    url: 'occupancy_closure_reports/next-scheduled' },
    generatePartialClosure:           { method: 'post',   url: 'occupancy_closure_reports/partial' },
    downloadClosureReport:            { method: 'get',    url: 'occupancy_closure_reports/{id}/download', responseType: 'blob' },
    resendClosureReportEmail:         { method: 'post',   url: 'occupancy_closure_reports/{id}/resend-email' },
}
